export default __webpack_public_path__ + "static/Entenda0070-8a7abb5a5af1b630a4b5261c2604cdd0.jpg";